"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createPartnerDatasetApiClient = void 0;
const shared_logger_1 = require("@aladin/shared-logger");
const shared_common_sdk_1 = require("@aladin/shared-common-sdk");
function createPartnerDatasetApiClient(options) {
    const logger = options.logger ?? shared_logger_1.NOOP_LOGGER;
    const client = (0, shared_common_sdk_1.createAxiosClient)(options.apiHost, {
        accessTokenSource: options.accessTokenSource,
        correlationIdSource: options.correlationIdSource,
    });
    const pathPartnerDataset = (partnerDatasetId) => {
        if (partnerDatasetId) {
            return `/v1/dataset/partners/${partnerDatasetId}`;
        }
        else {
            return `/v1/dataset/partners`;
        }
    };
    async function getPartnerDataset(params) {
        try {
            const response = await client.get(pathPartnerDataset(params.partnerDatasetId));
            return response.data;
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function createPartnerDataset(data) {
        try {
            const response = await client.post(pathPartnerDataset(), data);
            const location = response.headers.location || '';
            return location.replace('/v1/dataset/partners/', '');
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    async function deletePartnerDataset(params) {
        try {
            await client.delete(pathPartnerDataset(params.partnerDatasetId));
        }
        catch (err) {
            if (err instanceof Error)
                logger.debug('%s', err.stack);
            (0, shared_common_sdk_1.handleError)(err);
        }
    }
    return {
        getPartnerDataset,
        deletePartnerDataset,
        createPartnerDataset
    };
}
exports.createPartnerDatasetApiClient = createPartnerDatasetApiClient;
//# sourceMappingURL=data:application/json;base64,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